import { FC } from 'react'
import DrawingBlankForm from './forms/drawing-blank-form'
import FormReorderForm from './forms/form-reorder-form'
import { SupportedTaskCreationType, TaskCreationFormProps } from './types'

export const TASK_CREATION_FORMS: {
    [K in SupportedTaskCreationType]: FC<TaskCreationFormProps<K>>
} = {
    'Отрисовка бланка': DrawingBlankForm,
    'Перезаказ форм': FormReorderForm,
}
